module.exports = __webpack_public_path__ + "static/media/motorizada.62a94629.jpg";